import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { INVALID_GPM } from "../../configurations/MessageConstants";

function FieldWellDetails({ well, index, sharedField, updateWellDetails }) {
  const [active, setActive] = useState(well.activeWell);
  const [isElectric, setElectric] = useState(well.isElectricWell);
  const [ugpm, setUgpm] = useState(well.ugpm);

  useEffect(() => {
    setActive(well.activeWell);
    setElectric(well.isElectricWell);
    setUgpm(well.ugpm);
  }, [well]);

  useEffect(() => {
    updateWell();
  }, [active, isElectric, ugpm]);

  const toggleCheckbox = (e) => {
    setActive(!active);
  };

  const toggleElectricCheckbox = () => {
    setElectric(!isElectric);
  };

  const onWellUgpmChange = (e) => {
    setUgpm(e.target.value);
  };

  const updateWell = () => {
    updateWellDetails(
      {
        ...well,
        activeWell: active,
        isElectricWell: isElectric,
        ugpm: ugpm ? parseInt(ugpm) : parseInt(well.gpm),
      },
      index
    );
  };
  return (
    <tr key={index} className="field-well-rows">
      <td>Well {well.well_id}</td>
      <td>
        <Form.Check
          type="switch"
          checked={active}
          onChange={toggleCheckbox}
          disabled={sharedField ? true : false}
        />
      </td>
      <td>
        <Form.Check
          type="switch"
          checked={isElectric}
          onChange={toggleElectricCheckbox}
          disabled={sharedField ? true : false}
        />
      </td>
      <td>
        {" "}
        <Form.Control
          type="text"
          name={"wellGPM" + index + 1}
          value={well.gpm}
          readOnly
        />
      </td>
      <td>
        {" "}
        <Form.Control
          type="text"
          name={"audited_gpm" + index + 1}
          value={well.audited_gpm}
          readOnly
        />
      </td>
      <td>
        {" "}
        <Form.Control
          type="text"
          name={"updateWellGPM" + index + 1}
          value={ugpm}
          onChange={onWellUgpmChange}
          pattern="^[0-9]*"
          maxLength="4"
          readOnly={sharedField ? true : false}
        />
        <Form.Control.Feedback type="invalid">
          {INVALID_GPM}
        </Form.Control.Feedback>
      </td>
    </tr>
  );
}

export default FieldWellDetails;
